import React from 'react';
import { OrderedButton } from '@salt-ds/lab';
import { Button } from '@salt-ds/core';

import isEmpty from 'lodash/isEmpty';
import sessionHelper from 'utility/sessionStorageHelper';

const sanitizeForDpa = value =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

const ActionButton = props => {
  const {
    actionButton = false,
    innerRef,
    children,
    disabled,
    ordered,
    type = 'button',
    id,
    name,
    ['data-test-id']: dataTestId,
    ['data-dpa-asset-meta-component_id']: dpaComponentId,
    ['data-dpa-event-meta-interaction_name']: dpaInteractionName,
    ...rest
  } = props;
  const affectsDbAndIsSimulationUser = actionButton && !isEmpty(JSON.parse(sessionHelper.getItem('simulation')));
  const defaultComponentSuffix = sanitizeForDpa(id || dataTestId || name || type || 'action');
  const defaultInteractionName = sanitizeForDpa(typeof children === 'string' ? children : 'button_click');
  const analyticsComponentId = dpaComponentId || `c.button.${defaultComponentSuffix}`;
  const analyticsInteractionName = dpaInteractionName || defaultInteractionName;

  return !ordered ? (
    <Button
      ref={innerRef}
      type={type}
      id={id}
      name={name}
      data-test-id={dataTestId}
      data-dpa-asset-meta-component_id={analyticsComponentId}
      data-dpa-event-meta-interaction_name={analyticsInteractionName}
      disabled={disabled || affectsDbAndIsSimulationUser}
      {...rest}
    >
      {children}
    </Button>
  ) : (
    <OrderedButton
      ref={innerRef}
      type={type}
      id={id}
      name={name}
      data-test-id={dataTestId}
      data-dpa-asset-meta-component_id={analyticsComponentId}
      data-dpa-event-meta-interaction_name={analyticsInteractionName}
      disabled={disabled || affectsDbAndIsSimulationUser}
      {...rest}
    >
      {children}
    </OrderedButton>
  );
};

export default ActionButton;
